import { Utils, NumberUtils, ArgValidator, StringUtils, StringsFactory } from "neo-common";
import { AppContext } from "./AppContext";

function checkInitialized() {
    StringsFactory.checkInitialized();
}

export class Strings {
    private static _json: Object;

    constructor(json: Object) {
        ArgValidator.ensureIsNotNullOrUndefined(json, "json");
        Strings._json = json;
    }

    public static get loaded(): boolean {
        return !Utils.isNullOrUndefined(Strings._json);
    }

    public static get(key: string): string {
        return Strings._json && Strings._json.hasOwnProperty(key) ? Strings._json[key] : `@@${key}@@`;
    }

    public static getWithValues(key: string, ...tmpl: Array<any>): string {
        if (Strings._json && Strings._json.hasOwnProperty(key)) {
            var value = Strings._json[key];
            var regexFormat = /(\%m|\%s)/gm;
            var matchCnt = 0;
            while (regexFormat.exec(value)) {
                matchCnt++;
            }

            var args = tmpl;
            if (matchCnt !== args.length) {
                throw `Provided argument count (${args.length}) does not match required string params count (${matchCnt})`;
            }

            var idx = -1;
            return value.replace(regexFormat, function (match: string) {
                var val = args[++idx];
                if (StringUtils.equals(match, "%m", true)) {
                    val = NumberUtils.valueToNumber(
                        val,
                        AppContext.gameConfiguration.UseCoins ? 0 : AppContext.gameConfiguration.ShowDecimalPlaces,
                    );
                } else if (!StringUtils.equals(match, "%s", true)) {
                    throw `Unknown formatter "${match} !"`;
                }
                return val;
            });
        }

        return `@@${key}@@`;
    }

    /* SECTION FOR STRINGS GENERATOR - BEGIN (DO NOT MODIFY) */
    // public static get GAMBLE() { checkInitialized(); return this.get("GAMBLE"); }
    /* SECTION FOR STRINGS GENERATOR - END */
}

window["Strings"] = Strings;



/** WEBPACK FOOTER **
 ** ./Engine/Common/Strings.ts
 **/